import { render, staticRenderFns } from "./M_allocation.vue?vue&type=template&id=55991bda&scoped=true&"
import script from "./M_allocation.vue?vue&type=script&lang=js&"
export * from "./M_allocation.vue?vue&type=script&lang=js&"
import style0 from "./M_allocation.vue?vue&type=style&index=0&id=55991bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55991bda",
  null
  
)

export default component.exports